<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters } from "vuex";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Student Requirements",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // ModelListSelect,
  },
  data() {
    return {
      title: "Student Requirements",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Budget",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "expdate",
          label: "Date",
          sortable: true,
        },
        {
          key: "tot",
          label: "Total Amount",
          sortable: true,
        },
        {
          key: "paid",
          label: "Amount Paid",
          sortable: true,
        },
        {
          key: "mode",
          label: "Payment Mode",
          sortable: true,
        },
        {
          key: "supplier",
          label: "Supplier",
          sortable: true,
        },
        {
          key: "user",
          label: "Added By",
          sortable: true,
        },
        {
          key: "addedon",
          label: "Added On",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        amount: "",
        reason: "",
        id: "",
      },
      reasonError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("expenses", ["Expenses", "SaveStatus"]),
    ...mapGetters("modes", ["Modes"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Expenses ? this.Expenses.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Expenses ? this.Expenses.length : 1;
  },
  methods: {
    ...mapActions({
      FetchExpenses: "expenses/fetchExpenses",
      DeleteExpense: "expenses/deleteExpense",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.Expenses ? this.Expenses.length : 1;
      this.currentPage = 1;
    },

    showDeleteModal(values) {
      this.data.id = values.item.id;
      this.data.amount = values.item.tot;
    },
    resetErrors() {
      this.reasonError = "";
    },
    deleteExpense(modal) {
      if (this.data.reason == "") {
        this.reasonError = "Please provide a reason for deleting the expense";
        return;
      }
      this.modal = modal;
      this.DeleteExpense(this.data);
      this.closeModal(modal);
    },
    redirect(value) {
      this.$router.push(`/expense/details/${btoa(value)}`);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchExpenses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_expenses')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of All Expenses</h3>
              </div>
              <div class="col-3">
                <router-link to="/expenses/new"
                  ><button class="btn btn-primary float-end btn-sm">
                    <i class="fa fa-plus"></i> Add New
                  </button></router-link
                >
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Expenses ? Expenses : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="outline-success"
                      @click="redirect(data.item.id)"
                      ><i class="fa fa-bars"></i> Details</b-button
                    >
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      v-b-modal.delete-modal
                      @click="showDeleteModal(data)"
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- modal delete fyear starts -->
      <b-modal id="delete-modal" hide-footer>
        <template #modal-title>
          <h4 class="text-danger">
            Delete Expense of Amount {{ data.amount }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>Provide the reason below and proceed with the action.</h5>
          </div>
        </div>
        <div class="form-group mb-3">
          <div class="input-group">
            <textarea
              class="form-control"
              cols="30"
              rows="3"
              placeholder="Reason For Deleting"
              v-model="data.reason"
              @input="resetErrors()"
            ></textarea>
          </div>
        </div>
        <div class="text-danger" v-if="reasonError">
          <em>{{ reasonError }}</em>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger"
            @click="deleteExpense('delete-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
    <!-- modal ends -->
  </Layout>
</template>
<style scoped>
.required {
  color: red;
}
</style>
